import { type ReactNode } from 'react';

export enum APP_MODULE_CODE {
  HOME = 'HOME',
  ACCOUNTING = 'ACCOUNTING',
  HR = 'HR',
  DOCUMENT = 'DOCUMENT',
  E_OFFICE = 'E_OFFICE',
  TASK_MODULE = 'TASK_MODULE',
  UTILITY = 'UTILITY',
  SYSTEM = 'SYSTEM',
}

export enum APP_MENU_CODE {
  HOME = 'HOME',
  REPORT = 'REPORT',

  // Hành chính nhân sự
  HR_PERSONNEL = 'HR_PERSONNEL',
  HR_TIMEKEEPING = 'HR_TIMEKEEPING',
  HR_ASSET = 'HR_ASSET',
  HR_DEPARTMENT = 'HR_DEPARTMENT',

  // Kế toán - Công nợ
  ACCOUNTING_DEBTS = 'ACCOUNTING_DEBTS',
  ACCOUNTING_DATA_PROCESSING = 'ACCOUNTING_DATA_PROCESSING',
  ACCOUNTING_PENDING_DATA = 'ACCOUNTING_PENDING_DATA',
  ACCOUNTING_DEBT_REPORTS = 'ACCOUNTING_DEBT_REPORTS',

  // Kế toán - Thuế
  ACCOUNTING_TAX = 'ACCOUNTING_TAX',
  ACCOUNTING_INVOICE_REQUEST = 'ACCOUNTING_INVOICE_REQUEST',
  ACCOUNTING_ISSUED_INVOICE = 'ACCOUNTING_ISSUED_INVOICE',

  // Kế toán - Tổng hợp công nợ
  ACCOUNTING_DEBT_SUMMARY = 'ACCOUNTING_DEBT_SUMMARY',
  ACCOUNTING_CUSTOMER_DEBT_SUMMARY = 'ACCOUNTING_CUSTOMER_DEBT_SUMMARY',
  ACCOUNTING_SUPPLIER_DEBT_SUMMARY = 'ACCOUNTING_SUPPLIER_DEBT_SUMMARY',

  // Kế toán - Số dư đầu kỳ
  ACCOUNTING_OPENING_BALANCE = 'ACCOUNTING_OPENING_BALANCE',
  ACCOUNTING_RECEIVABLE_OPENING_BALANCE = 'ACCOUNTING_RECEIVABLE_OPENING_BALANCE',
  ACCOUNTING_PAYABLE_SUPPLIER_OPENING_BALANCE = 'ACCOUNTING_PAYABLE_SUPPLIER_OPENING_BALANCE',

  // Kế toán - Quản trị
  ACCOUNTING_ADMIN = 'ACCOUNTING_ADMIN',

  // Legacy Kế toán menu codes (kept for backwards compatibility)
  ACCOUNTING_SALES_DATA = 'ACCOUNTING_SALES_DATA',
  ACCOUNTING_REFUND_DATA = 'ACCOUNTING_REFUND_DATA',
  ACCOUNTING_SUPPLIER_DATA = 'ACCOUNTING_SUPPLIER_DATA',
  ACCOUNTING_BANK_DATA = 'ACCOUNTING_BANK_DATA',
  ACCOUNTING_CUSTOMER_PAYMENT_DATA = 'ACCOUNTING_CUSTOMER_PAYMENT_DATA',
  ACCOUNTING_RECEIVABLES = 'ACCOUNTING_RECEIVABLES',
  ACCOUNTING_SALES_REPORT = 'ACCOUNTING_SALES_REPORT',
  ACCOUNTING_TRANSACTION_REPORT = 'ACCOUNTING_TRANSACTION_REPORT',
  ACCOUNTING_DEBT_REPORT = 'ACCOUNTING_DEBT_REPORT',
  ACCOUNTING_PAYABLES = 'ACCOUNTING_PAYABLES',
  ACCOUNTING_SERVICE_REPORT = 'ACCOUNTING_SERVICE_REPORT',
  ACCOUNTING_PROVIDER_TOPUP = 'ACCOUNTING_PROVIDER_TOPUP',

  INTERNAL_DOCUMENT = 'INTERNAL_DOCUMENT',
  DOCUMENT_ADMIN = 'DOCUMENT_ADMIN',
  TASK = 'TASK',
  ADMIN_FORM = 'ADMIN_FORM',
  E_OFFICE_ADMIN = 'E_OFFICE_ADMIN',
  TASK_LIST = 'TASK_LIST',
  TASK_REPORT = 'TASK_REPORT',
  TASK_ADMIN = 'TASK_ADMIN',
  CALENDAR = 'CALENDAR',
  DIGITAL_SIGN = 'DIGITAL_SIGN',
  DIRECTORY = 'DIRECTORY',
  DOCUMENT_MGMT = 'DOCUMENT_MGMT',
  NOTICE = 'NOTICE',
  UTILITY_ADMIN = 'UTILITY_ADMIN',
  SYSTEM_PERMISSION = 'SYSTEM_PERMISSION',
  SYSTEM_ACCOUNT = 'SYSTEM_ACCOUNT',
  CATEGORY = 'CATEGORY',
  SIGN_ACCOUNTS = 'SIGN_ACCOUNTS',
}

export type TMenuItem = {
  key: string;
  label: ReactNode;
  code?: string;
  icon?: ReactNode;
  children?: TMenuItem[];
  type?: 'submenu' | 'item' | 'group' | 'divider';
  popupClassName?: string;
};
